<script lang='ts'>
  interface Props {
    deal: string;
  }

  const {deal}: Props = $props();
</script>

<div>
  {deal}
</div>

<style lang='scss'>
  @use '@otto-ec/design-tokens/tokens';

  div {
    font: tokens.$oc-semantic-font-headline-50;
    color: tokens.$oc-semantic-color-text-sale;
    white-space: nowrap;
    text-decoration: var(--tile-hover-decoration-none);
  }
</style>
